export default __webpack_public_path__ + "static/media/property_567.602a578d.png";